"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArcProxyInfoFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var ArcProxyInfoFactory = /** @class */ (function (_super) {
    __extends(ArcProxyInfoFactory, _super);
    function ArcProxyInfoFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    ArcProxyInfoFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    ArcProxyInfoFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    ArcProxyInfoFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    ArcProxyInfoFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    ArcProxyInfoFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return ArcProxyInfoFactory;
}(contracts_1.ContractFactory));
exports.ArcProxyInfoFactory = ArcProxyInfoFactory;
var _abi = [
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "proxy",
                type: "address",
            },
        ],
        name: "getProxyAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "proxy",
                type: "address",
            },
        ],
        name: "getProxyImplementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b5061037a806100206000396000f3fe608060405234801561001057600080fd5b50600436106100365760003560e01c8063204e1c7a1461003b578063f3b7dead14610064575b600080fd5b61004e6100493660046101b2565b610077565b60405161005b91906102d3565b60405180910390f35b61004e6100723660046101b2565b610119565b6000806060836001600160a01b0316604051610092906102bd565b600060405180830381855afa9150503d80600081146100cd576040519150601f19603f3d011682016040523d82523d6000602084013e6100d2565b606091505b5091509150816100fd5760405162461bcd60e51b81526004016100f4906102f1565b60405180910390fd5b8080602001905161011191908101906101d0565b949350505050565b6000806060836001600160a01b0316604051610134906102c8565b600060405180830381855afa9150503d806000811461016f576040519150601f19603f3d011682016040523d82523d6000602084013e610174565b606091505b5091509150816100fd5760405162461bcd60e51b81526004016100f4906102e1565b80356101a181610320565b92915050565b80516101a181610320565b6000602082840312156101c457600080fd5b60006101118484610196565b6000602082840312156101e257600080fd5b600061011184846101a7565b6101f78161030f565b82525050565b600061020a601c83610306565b7f67657450726f787941646d696e28293a2063616c6c206661696c656400000000815260200192915050565b6000610243602583610306565b7f67657450726f7879496d706c656d656e746174696f6e28293a2063616c6c2066815264185a5b195960da1b602082015260400192915050565b600061028a600483610301565b635c60da1b60e01b815260040192915050565b60006102aa600483610301565b6303e1469160e61b815260040192915050565b60006101a18261027d565b60006101a18261029d565b602081016101a182846101ee565b602080825281016101a1816101fd565b602080825281016101a181610236565b919050565b90815260200190565b60006001600160a01b0382166101a1565b6103298161030f565b811461033457600080fd5b5056fea365627a7a7231582093d93ab065df63b5f20c6d0bd942c3d003f93c79089db1af00cbe3514b30c8a26c6578706572696d656e74616cf564736f6c63430005100040";
